import { DateTime } from "../../../components/DateTime/index.js";
import "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Scheduling/shared/ShiftTimeLogStatusLabel.tsx
var SHIFT_TIME_LOG_STATUS_LABELS = {
	endbreak: "End Break",
	endshift: "End Shift",
	startbreak: "Start Break",
	startshift: "Start Shift"
};
function ShiftTimeLogStatusLabel({ shift }) {
	const lastTimeLogItem = shift?.timeLog[shift.timeLog.length - 1];
	if (!lastTimeLogItem) return null;
	return /* @__PURE__ */ jsxs("span", { children: [
		SHIFT_TIME_LOG_STATUS_LABELS[lastTimeLogItem.action] || lastTimeLogItem.action,
		" ",
		/* @__PURE__ */ jsxs("span", {
			className: "font-light",
			children: [
				"(",
				/* @__PURE__ */ jsx(DateTime, {
					relative: true,
					timestamp: lastTimeLogItem.timestamp
				}),
				")"
			]
		})
	] });
}
//#endregion
export { ShiftTimeLogStatusLabel };

//# sourceMappingURL=ShiftTimeLogStatusLabel.js.map